'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BiddingInfoRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BiddingInfoRemote = exports.BiddingInfoRemote = {
    fetchCatalogBidding: function fetchCatalogBidding(_ref) {
        var authToken = _ref.authToken,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/catalog/' + catalogId + '/bidding', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    },
    fetchItemBidding: function fetchItemBidding(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            itemId = _ref2.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/item/' + itemId + '/bidding', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/biddingInfo.js
// module id = bigW
// module chunks = 46